module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/projects/bluetooth-printers-distribution/"},"frontmatter":{"title":"Bluetooth Printers Distribution"}}}]}},"pathContext":{"tag":"printer"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-printer.json
// module id = 472
// module chunks = 178011258625661